(function() {
  'use strict';
  
  // Add loaded class to body when page is ready (for initial page load animations)
  function initFadeAnimations() {
    // Small delay to ensure smooth initial fade
    setTimeout(function() {
      document.body.classList.add('loaded');
    }, 100);
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeAnimations);
  } else {
    initFadeAnimations();
  }

  // Intersection Observer for scroll-triggered fade-ins
  const observerOptions = {
    threshold: 0.15, // Element needs to be 15% visible before fading in
    rootMargin: '0px 0px -100px 0px' // Start animation 100px before element enters viewport
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        // Stop observing once visible
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Wait for page to be fully loaded, then observe elements
  window.addEventListener('load', function() {
    // Observe all elements with fade-in-element class
    const fadeElements = document.querySelectorAll('.fade-in-element');
    fadeElements.forEach(function(element) {
      observer.observe(element);
    });

    // Also observe sections below the fold
    const sections = document.querySelectorAll('section, .section, [class*="section"]');
    sections.forEach(function(section) {
      const rect = section.getBoundingClientRect();
      // If element is below the visible viewport
      if (rect.top > window.innerHeight) {
        section.classList.add('fade-in-element');
        observer.observe(section);
      }
    });
  });
})();